import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import VerticalCenter from 'src/vertical-center/vertical-center';
import { styles } from './search-products-header-control-styles';

const SearchProductsHeaderControl = (): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <Grid direction='column' spacing={0} wrap='nowrap' container className={classes.itemContainer}>
      <Grid item className='fullHeight'>
        <Grid container justifyContent='flex-start'>
          <Grid item xs={6} className={classes.productNameContainer}>
            <VerticalCenter containerClass={classes.productNameContainer} itemClass='fullWidth'>
              {t('ItemName')}
            </VerticalCenter>
          </Grid>
          <Grid item xs={4} className={classes.itemCodeContainer}>
            <VerticalCenter
              containerClass={classes.itemCodeContainer}
              itemClass={classes.productInformation}
            >
              {t('OnlineItemBalanceInquiry_ItemCode')}
            </VerticalCenter>
          </Grid>
          <Grid item xs={2} className={classes.itemCodeContainer}>
            <VerticalCenter
              containerClass={classes.itemCodeContainer}
              itemClass={classes.priceInformation}
            >
              {t('PriceQueryView_Price')}
            </VerticalCenter>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default React.memo(SearchProductsHeaderControl);
